export const dashboardActionRoutes: Record<string, string> = {
  futureDeliveries: '/my-deliveries',
  getHelp: '/get-help',
  manageSubscription: '/subscription-settings',
  orderBox: '/delivery-details',
  raf: '/my-referrals',
  restartSubscription: '/subscription-settings',
}
